module.exports = __webpack_public_path__ + "img/icon-location.81a3adee.svg";